<template>
  <section class="contact" id="contact">
    <div class="container">
      <div class="contact-content">
        <div class="contact-info">
          <h2 class="section-title">让我们一起创造未来</h2>
          <p class="section-description">
            我们相信技术的力量能够改变世界。如果您有创新的想法或需要技术支持，
            欢迎与我们联系，让我们一起创造更美好的数字未来。
          </p>
          
          <div class="contact-qr">
            <div class="qr-section">
              <div class="qr-container">
                <div class="qr-item" v-for="qr in qrCodes" :key="qr.id">
                  <div class="qr-image">
                    <img :src="qr.image" :alt="qr.alt" class="qr-code" />
                  </div>
                  <p class="qr-description">{{ qr.description }}</p>
                </div>
              </div>
            </div>
            
            <div class="contact-details">
              <div class="contact-item" v-for="detail in contactDetails" :key="detail.id">
                <div class="contact-icon">{{ detail.icon }}</div>
                <div class="contact-text">{{ detail.text }}</div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="contact-form">
          <h3 class="form-title">发送消息给我们</h3>
          <form @submit.prevent="submitForm" class="form">
            <div class="form-group">
              <input 
                type="text" 
                v-model="form.name" 
                placeholder="姓名" 
                class="form-input"
                required
              >
            </div>
            <div class="form-group">
              <input 
                type="email" 
                v-model="form.email" 
                placeholder="电子邮件" 
                class="form-input"
                required
              >
            </div>
            <div class="form-group">
              <input 
                type="text" 
                v-model="form.subject" 
                placeholder="主题" 
                class="form-input"
                required
              >
            </div>
            <div class="form-group">
              <textarea 
                v-model="form.message" 
                placeholder="消息" 
                class="form-textarea"
                rows="4"
                required
              ></textarea>
            </div>
            <button type="submit" class="btn btn-primary btn-large">发送消息</button>
          </form>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ContactSection',
  data() {
    return {
      form: {
        name: '',
        email: '',
        subject: '',
        message: ''
      },
      qrCodes: [
        {
          id: 1,
          image: require('../assets/concat-wechat.jpg'),
          alt: '企业微信二维码',
          description: '企业微信扫码添加'
        },
        {
          id: 2,
          image: require('../assets/concat-dingtalk.jpg'),
          alt: '钉钉二维码',
          description: '钉钉扫码添加'
        },
        {
          id: 3,
          image: require('../assets/concat-feishu.png'),
          alt: '飞书二维码',
          description: '飞书扫码添加'
        }
      ],
      contactDetails: [
        {
          id: 1,
          icon: '📍',
          text: '呼和浩特市赛罕区南二环路北侧汇商广场A座11楼11059号'
        },
        // {
        //   id: 2,
        //   icon: '📞',
        //   text: '+86 400-888-8888'
        // },
        // {
        //   id: 3,
        //   icon: '✉️',
        //   text: 'contact@nexuslabs.com'
        // }
      ]
    }
  },
  methods: {
    async submitForm() {
      try {
        // 显示加载状态
        const submitButton = document.querySelector('.btn-primary')
        // const originalText = submitButton.textContent
        submitButton.textContent = '发送中...'
        submitButton.disabled = true

        // 发送API请求
        const response = await fetch('/api/qsource/cec50dfe-0a6a-4179-a301-975c87e17480', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            name: this.form.name,
            email: this.form.email,
            subject: this.form.subject,
            message: this.form.message
          })
        })

        if (response.ok) {
          // 请求成功
          alert('消息发送成功！我们会尽快回复您。')
          
          // 重置表单
          this.form = {
            name: '',
            email: '',
            subject: '',
            message: ''
          }
        } else {
          // 请求失败
          throw new Error(`HTTP error! status: ${response.status}`)
        }
      } catch (error) {
        console.error('发送消息失败:', error)
        
        // 处理跨域错误或其他错误
        if (error.name === 'TypeError' && error.message.includes('fetch')) {
          alert('网络连接失败，请检查网络连接后重试。')
        } else {
          alert('发送消息失败，请稍后重试。')
        }
      } finally {
        // 恢复按钮状态
        const submitButton = document.querySelector('.btn-primary')
        submitButton.textContent = '发送消息'
        submitButton.disabled = false
      }
    }
  }
}
</script>

<style scoped>
.contact {
  padding: 100px 0;
  background: #ffffff;
  border-top: 1px solid #e5e7eb;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.contact-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 80px;
  align-items: start;
}

.contact-info {
  max-width: 500px;
}

.section-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0 0 24px 0;
}

.section-description {
  font-size: 1.125rem;
  line-height: 1.7;
  color: #6b7280;
  margin: 0 0 48px 0;
}

.contact-qr {
  display: flex;
  flex-direction: column;
  gap: 32px;
}

.qr-section {
  text-align: center;
}

.qr-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #1f2937;
  margin: 0 0 24px 0;
}

.qr-container {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 24px;
  flex-wrap: nowrap;
}

.qr-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.qr-image {
  width: 140px;
  height: 140px;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  background: white;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.qr-code {
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 8px;
}

.qr-description {
  font-size: 0.8rem;
  color: #6b7280;
  margin: 0;
  text-align: center;
  line-height: 1.4;
}

.contact-details {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.contact-item {
  display: flex;
  align-items: center;
  gap: 16px;
}

.contact-icon {
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, #3C59FF, #09D6F9);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.25rem;
  flex-shrink: 0;
}

.contact-text {
  font-size: 1rem;
  color: #374151;
  font-weight: 500;
}

.contact-form {
  background: white;
  padding: 48px;
  border-radius: 16px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  border: 1px solid #e5e7eb;
}

.form-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #1f2937;
  margin: 0 0 32px 0;
}

.form {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-input,
.form-textarea {
  padding: 16px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 1rem;
  transition: all 0.3s ease;
  background: white;
}

.form-input:focus,
.form-textarea:focus {
  outline: none;
  border-color: #8b5cf6;
  box-shadow: 0 0 0 3px rgba(139, 92, 246, 0.1);
}

.form-textarea {
  resize: vertical;
  min-height: 120px;
}

.btn-primary {
  background: linear-gradient(135deg, #3C59FF, #09D6F9);
  color: white;
  border: none;
  align-self: flex-start;
}

.btn-primary:hover {
  background: linear-gradient(135deg, #2A2B32, #00EDB2);
  transform: translateY(-2px);
}

.btn-primary:disabled {
  background: #9ca3af;
  cursor: not-allowed;
  transform: none;
}

.btn-primary:disabled:hover {
  background: #9ca3af;
  transform: none;
}

@media (max-width: 768px) {
  .contact {
    padding: 60px 0;
  }
  
  .container {
    padding: 0 16px;
  }
  
  .contact-content {
    grid-template-columns: 1fr;
    gap: 40px;
  }
  
  .section-title {
    font-size: 1.75rem;
    line-height: 1.3;
  }
  
  .section-description {
    font-size: 1rem;
    margin-bottom: 32px;
  }
  
  .contact-form {
    padding: 24px;
  }
  
  .form-title {
    font-size: 1.25rem;
    margin-bottom: 24px;
  }
  
  .form-input,
  .form-textarea {
    font-size: 16px; /* 防止iOS缩放 */
    padding: 12px 16px;
  }
  
  .btn {
    width: 100%;
    padding: 14px 24px;
    font-size: 1rem;
  }
  
  .contact-qr {
    gap: 24px;
  }
  
  .qr-container {
    gap: 16px;
    flex-wrap: wrap;
  }
  
  .qr-image {
    width: 120px;
    height: 120px;
    padding: 8px;
  }
  
  .qr-description {
    font-size: 0.75rem;
  }
  
  .qr-container {
    gap: 16px;
    flex-wrap: wrap;
    justify-content: center;
  }
  
  .qr-image {
    width: 120px;
    height: 120px;
    padding: 8px;
  }
  
  .qr-description {
    font-size: 0.75rem;
  }
  
  .contact-details {
    gap: 20px;
  }
  
  .contact-item {
    gap: 12px;
  }
  
  .contact-icon {
    width: 40px;
    height: 40px;
    font-size: 1rem;
  }
}
</style>
